export const SET_DEVICE = (value) => { // informations du device utilisateur (taille de l'écran, mobile/desktop)
  return (dispatch) => {
    dispatch({
      value: value,
      type: 'SET_DEVICE'
    })
  }
}
